<template>
  <div class="container comparison-container noHoverBG">
    <div class="table-header-box">
      <span class="table-header-title">{{$t('T_LENSES')}}</span>
      <span class="table-header-result" v-if="tableDataLens.length > 0">
        <span class="block">(</span>
        <span>{{tableDataLens.length}}</span>
        <span>{{$t('T_RESULT')}}</span>
        <span class="block">)</span>
      </span>
      <span class="table-header-result" v-else>( {{$t('T_NOT_SUPPORTED_EXCHANGE')}} )</span>
      <el-button class="projector-result_button ellipsis" v-show="tableDataLens.length > 0" type="button" @click="dialogVisible = true" :title="$t('T_SPEC_INFO')">{{$t('T_SPEC_INFO')}}</el-button>
      <el-button class="projector-result_button ellipsis" v-show="tableDataLens.length > 0" type="button" @click="shiftTab = !shiftTab" :title="$t('T_SWITCH_DISPLAY')">{{$t('T_SWITCH_DISPLAY')}}</el-button>
    </div>
    <el-table tooltip-effect="dark" ref="showTable" :data='tableDataLens' max-height='177' border style='width: 100%' @current-change='onLensChange'
      @row-click='handleCurrentChanges' align="center" highlight-current-row :class="{lensTable :isIE}" id="lensTable" :row-class-name="tableRowClassName">
      <el-table-column prop='radio' label width='25' key="radio" >
        <template slot-scope='scope'>
          <el-radio  v-removeAria v-model='radioLens' :label='scope.$index'>&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop='name' show-overflow-tooltip :label="$t('T_LENSES')" width='125' key="name" :render-header="renderheader">
        <template slot-scope='scope'>
          <span :class = "{oldLens: scope.row.isOldLens || scope.row.discontinued}">{{scope.row.name.substr(0, scope.row.name.indexOf(scope.row.vcode))}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='distance' show-overflow-tooltip :label="$t('T_THROW_RATIO')" :resizable="false" v-if="shiftTab" key="distance" :render-header="renderheader">
        <template slot-scope='scope'>
          <span :class = "{oldLens: scope.row.isOldLens || scope.row.discontinued}">{{scope.row.throwRatio}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='address' :width=throwRangeColWidth :min-width=throwRangeColWidth :resizable="false" v-if="shiftTab" key="address">
        <template slot='header' slot-scope='scope'>
          <span>{{$t('T_THROW_RATIO')}}{{ scope.row }}</span>
          <span class="span-scale span_throw_range_min">{{ throwRangeMin }}</span>
          <span class="span-scale span_throw_range_one">{{(throwRangeMax / 15 * 5)}}</span>
          <span class="span-scale span_throw_range_two">{{throwRangeMax / 15 * 10}}</span>
          <span class="span-scale span_throw_range_max">{{ throwRangeMax }}</span>
        </template>
        <template slot-scope='scope'>
          <div class="throw-range-container">
            <div v-for="(item, index) in throwRangeDiv" :key='index' class="dividing-line">
            </div>
            <div class="throw-range" :style='scope.row.style'></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop='vcode' :width=vCodeWidth :label="$t('T_V_CODE')"  key="vcode" v-if="!shiftTab" :render-header="renderheader">
        <template slot-scope='scope'>
          <span :class = "{oldLens: scope.row.isOldLens || scope.row.discontinued}">{{scope.row.vcode}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='throwRatio' :width=zoomRatioWidth :label="$t('T_THROW_RATIO')"  key="throwRatio" v-if="!shiftTab" :render-header="renderheader">
        <template slot-scope='scope'>
          <span :class = "{oldLens: scope.row.isOldLens || scope.row.discontinued}">{{scope.row.throwRatio}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='vLensShift' :label="$t('T_LENSSHIFT_V')" key="vLensShift" v-if="!shiftTab" :render-header="renderheader">
        <template slot-scope='scope'>
          <span :class = "{oldLens: scope.row.isOldLens || scope.row.discontinued}">{{scope.row.vLensShift}}</span>
        </template>
      </el-table-column>
      <el-table-column prop='hLensShift' :label="$t('T_LENSSHIFT_H')" key="hLensShift" v-if="!shiftTab" :render-header="renderheader">
        <template slot-scope='scope'>
          <span :class = "{oldLens: scope.row.isOldLens || scope.row.discontinued}">{{scope.row.hLensShift}}</span>
        </template>
      </el-table-column>
      <div slot="empty">
          {{$t('T_NO_RESULT')}}
      </div>
    </el-table>
    <el-dialog title :visible.sync="dialogVisible" width="27%" center class="slot-title">
      <div slot="title">
        <div class="info">
          <span class="projector-title">{{$t('T_LENS_INFO')}}</span>
          <img :src="lensImgUrl" class="dialog-img">
          <p>{{selectedLensData.name}}</p>
        </div>
      </div>
      <div class="lensDetailedInfo" v-for="(item, index) in listInfo" :key="index">
        <div :class = "{ unitDisplay: item.name === 'T_INFO_WEIGHT' || 'T_SUPPORTED_SCREEN_SIZE'}">{{$t(item.name)}} : {{ item.value }}</div>
        <span v-show="item.name === 'T_SUPPORTED_SCREEN_SIZE'">{{$t('T_INCH')}}</span>
        <span v-show="item.name === 'T_INFO_WEIGHT'">{{$t('T_KILOGRAM_KG')}}</span>
        <hr />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{$t('T_OK')}}</el-button>
      </span>
    </el-dialog>
    <!-- レンズ選択時、条件に応じてダイアログを表示する -->
    <el-dialog :visible.sync="selectLensDialog" width="480px" :close-on-click-modal="false" class="select_lens_note_dialog" center>
        <div>
          <p v-show="showNoteMsg1">{{$t('T_SELECT_LENS_NOTE_MSG1')}}</p>
          <p v-show="showNoteMsg2">{{$t('T_SELECT_LENS_NOTE_MSG2')}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="selectLensDialog = false" size="medium">{{$t('T_OK')}}</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  data () {
    return {
      currentRowLens: null,
      radioLens: 0,
      dialogVisible: false,
      selectLensDialog: false,
      showNoteMsg1: false,
      showNoteMsg2: false,
      listInfo: [],
      tableDataLens: [],
      screenSize: '',
      zoomRatio: '',
      selectedLensId: '',
      throwRangeDivLength: 15,
      throwRangeMin: 0,
      throwRangeColWidth: '330',
      oldLensArr: ['ELPLU02', 'ELPLR04', 'ELPLW04', 'ELPLS04', 'ELPLM06', 'ELPLM07', 'ELPLL07', 'ELPLM09'],
      shiftTab: false, // true显示tab1 false显示tab2
      selectedModel: this.$store.state.selectedModelData.name,
      oldSelectedModel: this.$store.state.selectedModelData.name
    }
  },
  computed: {
    ...mapState(['searchTabActive', 'selectedModelData', 'selectedLensData', 'matchingLensID', 'aspectRatio', 'cateRadio',
      'graph', 'vLensShiftNow', 'hLensShiftNow', 'vAngle', 'hAngle', 'position', 'browserType', 'throwDistance2screenSizWidth', 'blendingParam', 'screenSizeChecked', 'isSimple']),
    ...mapGetters(['selectedLensData_lcd_distInfo']),
    isIE () {
      return this.browserType !== 'other'
    },
    lensImgUrl () {
      if (this.selectedLensData && this.selectedLensData.url) {
        let data = this.selectedLensData.url
        return data + '.jpg'
      }
    },
    throwRangeDiv () {
      return this.$commonJs.getThrowRangeDiv(this.throwRangeDivLength)
    },
    currentUnit () {
      return this.graph.unit
    },
    throwRangeMax () {
      // let val
      // switch (this.graph.unit) {
      //   case 'T_METRE_M':
      //     val = 300
      //     break
      //   case 'T_MILLIMETER_MM':
      //     val = 300000
      //     break
      //   case 'T_FEET_DECIMAL':
      //     val = 900
      //     break
      //   case 'T_INCH_DECIMAL':
      //     val = 12000
      //     break
      // }
      return 12
    },
    throwRangeLang () {
      let val
      switch (this.graph.unit) {
        case 'T_METRE_M':
          val = 'T_LENS_THROW_RANGE_M'
          break
        case 'T_MILLIMETER_MM':
          val = 'T_LENS_THROW_RANGE_MM'
          break
        case 'T_FEET_DECIMAL':
          val = 'T_LENS_THROW_RANGE_FEET'
          break
        case 'T_INCH_DECIMAL':
          val = 'T_LENS_THROW_RANGE_INCH'
          break
      }
      return val
    },
    vCodeWidth () {
      if (this.$i18n.locale === 'en') {
        return 120
      }
      if (this.$i18n.locale === 'ja') {
        return 97
      }
      if (this.$i18n.locale === 'zh') {
        return 120
      }
    },
    zoomRatioWidth () {
      if (this.$i18n.locale === 'en') {
        return 100
      }
      if (this.$i18n.locale === 'ja') {
        return 80
      }
      if (this.$i18n.locale === 'zh') {
        return 100
      }
    },
    current_position () {
      // return this.searchTabActive === 'Blending' ? Number(this.blendingParam.position) : this.position
      return this.position
    }
  },
  watch: {
    selectedModelData: {
      handler (val, oldVal) {
        // console.log('watch oldVal.name:', oldVal.name, 'val.name:', val.name)
        this.oldSelectedModel = oldVal.name
        this.selectedModel = val.name
        if (oldVal.name !== val.name) {
          this.setSpecificInfo(this.selectedLensData)
        }
        this.oldSelectedModel = val.name
        // console.log('watch this.oldSelectedModel:', this.oldSelectedModel, 'this.selectedModel:', this.selectedModel)
      },
      deep: true
    },
    matchingLensID (val) {
      this.setTableData()
    },
    selectedLensData (val) {
      this.setSpecificInfo(val)
      if (val.id) {
        this.findRadioIndexByLensId(val.id)
      }
    },
    currentUnit (val) {
      this.setTableData()
    }
  },
  mounted () {
    this.setTableData()
    if (this.selectedLensData.id) {
      this.findRadioIndexByLensId(this.selectedLensData.id)
    }
  },
  methods: {
    ...mapMutations([
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'VLENSSHIFT', 'SET_VLENSSHIFT',
      'HLENSSHIFT', 'SET_HLENSSHIFT',
      'VHLENSSHIFT',
      'ASPECTRATIO',
      'SET_VANGLE', 'SET_HANGLE', 'SET_VANGLEFLAG', 'SET_INDANGLESWITCH', 'SET_HANGLEFLAG',
      'SELECTEDLENSDATA', 'SEARCHSELECTEDLENSDATA', 'BMSELECTEDLENSDATA', 'SET_DASHFLAG', 'SET_TEMVLENSSHIFT', 'SET_ISUSTWALL', 'SET_LENSLIST', 'SET_SCREENSIZECHECKED'
    ]),

    handleCurrentChanges (val) {
      this.currentRowLens = val
      let index = this.tableDataLens.findIndex(
        item => item.id === this.currentRowLens.id
      )
      if (index > -1) {
        this.radioLens = index
      }
    },
    findRadioIndexByLensId (val) {
      setTimeout(() => {
        this.changeScroll()
      }, 0)
      let index = this.tableDataLens.findIndex(
        item => item.id === val
      )
      if (index > -1) {
        this.radioLens = index
      }
    },
    changeScroll () {
      if (document.querySelector('.el-table__row')) {
        let height = document.querySelector('.el-table__row').offsetHeight ? document.querySelector('.el-table__row').offsetHeight : 23
        this.$refs.showTable.$el.querySelector('.el-table__body-wrapper').scrollTo({top: this.radioLens * height})
      }
    },
    setSpecificInfo (data) {
      // let defaultRatio = data.lcd.aspectRatio
      let defaultRatio
      // console.log('setSpecificInfo this.oldSelectedModel:', this.oldSelectedModel, 'this.selectedModel:', this.selectedModel)
      // console.log('setSpecificInfo data.lcd.aspectRatio:', data.lcd.aspectRatio)
      // console.log('setSpecificInfo this.aspectRatio:', this.aspectRatio)
      const hasAspectRatio = this.selectedLensData_lcd_distInfo.some(item => item.ratio === this.aspectRatio)
      // 当前选择的 宽高比 不支持的场合，使用默认的宽高比
      // 简易模式下，投影仪变更的场合，使用默认的宽高比
      // 非简易模式下，没有枷锁且投影仪变更的场合，使用默认的宽高比
      // 以外的场合，宽高比维持原来选择的宽高比
      if (!hasAspectRatio ||
       (this.isSimple && this.oldSelectedModel !== this.selectedModel) ||
       (!this.isSimple && !this.screenSizeChecked && this.oldSelectedModel !== this.selectedModel)) {
        defaultRatio = data.lcd.aspectRatio
        this.ASPECTRATIO(defaultRatio)
      } else {
        defaultRatio = this.aspectRatio
      }
      if (!hasAspectRatio && this.screenSizeChecked) {
        this.SET_SCREENSIZECHECKED(false)
      }
      let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(defaultRatio, data)
      let size = defaultDistInfo.screenSize
      let sizeMin = size.w.min
      let sizeMax = size.t.max ? size.t.max : size.w.max
      this.listInfo = [{
        name: 'T_F_NUMBER',
        value: data['fNum']
      }, {
        name: 'T_FOCAL_LENGTH',
        value: data['focalLength']
      }, {
        name: 'T_THROW_RATIO',
        value: data['throwRatio']
      }, {
        name: 'T_DIMENSION',
        value: data['dimension']
      }, {
        name: 'T_SUPPORTED_SCREEN_SIZE',
        value: sizeMin + ' - ' + sizeMax
      },
      {
        name: 'T_INFO_WEIGHT',
        value: data['weight']
      }]
      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)
      let vals = {}
      if (this.current_position === 0) {
        vals = data.lcd.lensShiftRange.v
        if (data.lcd.lensShiftRange.v.min > 0) {
          this.SET_VLENSSHIFT(data.lcd.lensShiftRange.v.min * 100)
        } else if (this.vLensShiftNow) {
          this.SET_VLENSSHIFT(0)
        }
      } else if (this.current_position === 1 || this.current_position === 2) {
        vals.max = data.lcd.lensShiftRange.v.min * -1
        vals.min = data.lcd.lensShiftRange.v.max * -1
        if (vals.max < 0) {
          this.SET_VLENSSHIFT(vals.max * 100)
        } else if (this.vLensShiftNow) {
          this.SET_VLENSSHIFT(0)
        }
      }

      if (data.lcd.lensShiftRange.h.min > 0) {
        this.SET_HLENSSHIFT(data.lcd.lensShiftRange.h.min * 100)
      } else if (this.hLensShiftNow) {
        this.SET_HLENSSHIFT(0)
      }

      if (this.vAngle) {
        this.SET_VANGLE(0)
      }
      if (this.hAngle) {
        this.SET_HANGLE(0)
      }
      this.SET_VANGLEFLAG(false)
      this.SET_INDANGLESWITCH(false)
      this.SET_HANGLEFLAG(false)
      this.SET_DASHFLAG(false)

      this.VLENSSHIFT(vals)
      this.SET_TEMVLENSSHIFT(vals)
      this.HLENSSHIFT(data.lcd.lensShiftRange.h)
      this.VHLENSSHIFT(data.lcd.lensShiftRange.hv)

      // 为超短焦设置默认vlens shift
      if (this.selectedModelData.type === 1 && data.lcd.lensShiftRange.v.min === 0 && data.lcd.lensShiftRange.v.max === 0) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let v1b = defaultDistInfo.screenSize.w.min * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        let res = (initSize.calY / 2 + v1b - data.mu) / initSize.calY
        let va = {}
        if ((this.current_position === 1 || this.current_position === 2)) {
          this.SET_VLENSSHIFT(res * 100 * -1)
        } else {
          this.SET_VLENSSHIFT(res * 100)
        }
        va.max = res
        va.min = res
        this.VLENSSHIFT(va)
        this.SET_TEMVLENSSHIFT(va)
      } else if (this.$commonViewJs.isLongLensExistsLens()) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        if (!initSize) return

        let res = (defaultDistInfo.wv.wv2 * defaultDistInfo.screenSize.w.min - initSize.calY / 2) / initSize.calY
        // let res = (1.35799 * defaultDistInfo.screenSize.w.min - initSize.calY / 2) / initSize.calY

        this.SET_VLENSSHIFT(res * 100)
        let va = {}
        va.max = res
        va.min = res
        this.VLENSSHIFT(va)
        this.SET_TEMVLENSSHIFT(va)
      }

      // 判断是否显示超短焦专用画面
      if (this.selectedModelData.category === 4) {
        this.SET_ISUSTWALL(true)
      } else {
        this.SET_ISUSTWALL(false)
      }
    },

    onLensChange (value) {
      if (!value) {
        return
      }
      this.selectedLensId = value.id
      let data = this.$commonJs.findLensDataByIdAndSize(value.id, this.selectedModelData.lcdSize)
      this.commitSelectedLensData(data)
      if (this.getEAI() && this.getBrightnessLimit()) {
        this.selectLensDialog = true
        this.showNoteMsg1 = true
        this.showNoteMsg2 = false
      } else if (this.getEAI() && !this.getBrightnessLimit()) {
        this.selectLensDialog = true
        this.showNoteMsg1 = true
        this.showNoteMsg2 = false
      } else if (!this.getEAI() && this.getBrightnessLimit()) {
        this.selectLensDialog = true
        this.showNoteMsg1 = false
        this.showNoteMsg2 = true
      } else {
        this.selectLensDialog = false
        this.showNoteMsg1 = false
        this.showNoteMsg2 = false
      }
    },
    getBrightnessLimit (id) {
      let brightnessLimit
      if (this.selectedModelData.lensExchange) {
        let code = this.selectedModelData.code
        let lensId = id || this.selectedLensData.id
        brightnessLimit = this.Brightness.optionLens.find(
          item => item.code === code && item.lensId === lensId
        ).BrightnessLimit
      }
      return brightnessLimit
    },
    getEAI (id) {
      let brightnessEAI
      if (this.selectedModelData.lensExchange) {
        let code = this.selectedModelData.code
        let lensId = id || this.selectedLensData.id
        let pjName = this.selectedModelData.name
        if (pjName.indexOf('Pro') !== -1) {
          let EAIArr = this.Brightness.optionLens.filter((item) => {
            return item.code === code && item.lensId === lensId
          })
          if (EAIArr.length > 1) {
            brightnessEAI = EAIArr.find(item => item.EAI === true).EAI
          } else {
            brightnessEAI = EAIArr[0].EAI
          }
          return brightnessEAI
        }
        return this.Brightness.optionLens.find(item => item.code === code && item.lensId === lensId).EAI
      }
    },
    commitSelectedLensData (data) {
      this.SELECTEDLENSDATA(data)
      if (this.searchTabActiveName === 'Search') {
        this.SEARCHSELECTEDLENSDATA(data)
      } else {
        if (this.cateRadio === 'bmRadio') {
          this.BMSELECTEDLENSDATA(data)
        }
      }
    },
    tableRowClassName ({row, rowIndex}) {
      // EAI生産終了品 brightnessLimit明るさ制限の有無
      if ((row.EAI && row.brightnessLimit) || (row.EAI && !row.brightnessLimit)) {
        // 背景 濃灰色
        // 文字色変更 薄灰色
        return 'discontinued oldLens'
      } else if (!row.EAI && row.brightnessLimit) {
        // 文字色 濃灰色
        return 'oldLensGray'
      } else {
        return ''
      }
    },
    setTableData () {
      if (this.matchingLensID && this.matchingLensID.length) {
        // 解决firefox下表头错位问题
        setTimeout(() => {
          if (this.$refs && this.$refs.showTable) {
            this.$refs.showTable.doLayout()
          }
        }, 0)
        let isMainOLConfig = this.OptionLensSpec[0].isMainOLConfig
        this.tableDataLens = this.matchingLensID.map((item) => {
          const lensId = item.id
          let lensDataAll = this.$commonJs.findLensDataByIdAndSize(lensId, this.selectedModelData.lcdSize)
          // let throwRange
          let throwRatioToUnit
          let style
          let isOldLens = false
          let throwRatio
          let vLensShift
          let hLensShift
          let discontinued
          let throwRatioMin
          let throwRatioMax

          if (this.oldLensArr.indexOf(lensId) !== -1) {
            isOldLens = true
          }
          if (lensDataAll) {
            if (isMainOLConfig === 1) {
              discontinued = lensDataAll.discontinued
            }
            // let distInfo = lensDataAll.lcd.distInfo.find(item => item.ratio === lensDataAll.lcd.aspectRatio)
            // throwRange = {min: distInfo.throwRange.w.min, max: distInfo.throwRange.t.max ? distInfo.throwRange.t.max : distInfo.throwRange.w.max}
            throwRatio = lensDataAll.throwRatio
            let throwRatioArr = throwRatio.split('-')
            throwRatioMin = throwRatioArr[0] * 1
            throwRatioMax = throwRatioArr.length > 1 ? throwRatioArr[1] * 1 : throwRatioMin

            let lenShiftRange = lensDataAll.lcd.lensShiftRange
            vLensShift = parseInt(lenShiftRange.v.min * 100) + '% --- ' + parseInt(lenShiftRange.v.max * 100) + '%'
            hLensShift = parseInt(lenShiftRange.h.min * 100) + '% --- ' + parseInt(lenShiftRange.h.max * 100) + '%'
          }
          throwRatioToUnit = {min: throwRatioMin, max: throwRatioMax}
          let distance = throwRatio ? throwRatioMin + '----' + throwRatioMax : null
          if (throwRatio) {
            style = this.$commonJs.calcThrowRangeStyle(this.throwRangeColWidth, this.throwRangeMax, throwRatioToUnit)
          }
          let vcode = item.name.substring(item.name.indexOf(')') + 1, item.name.length).trim()
          let EAI = this.getEAI(lensId)
          let brightnessLimit = this.getBrightnessLimit(lensId)
          let data = {
            vcode: vcode,
            name: item.name,
            id: lensId,
            distance: distance,
            style: style,
            isOldLens: isOldLens,
            throwRatio: throwRatio,
            vLensShift: vLensShift,
            hLensShift: hLensShift,
            discontinued: discontinued,
            throwRatioMin: throwRatioMin,
            EAI: EAI,
            brightnessLimit: brightnessLimit,
            lensDataAll: lensDataAll
          }
          return data
        })
        this.tableDataLens = this.$commonJs.dataSortByNumber(this.tableDataLens, 'throwRatioMin')
        // InstallCondition 部分的特殊处理
        if (this.searchTabActive === 'InstallCondition' || this.searchTabActive === 'Specification') {
          this.$nextTick(() => {
            for (let i = 0; i < this.tableDataLens.length; i++) {
              if (this.searchTabActive === 'InstallCondition') {
                if (this.tableDataLens[i].throwRatio.indexOf('-') !== -1) {
                  let temp = this.tableDataLens[i].throwRatio.split('-')
                  if (temp.length < 2) {
                    if (temp[0].trim() === this.throwDistance2screenSizWidth) {
                      this.radioLens = i
                      break
                    }
                  } else {
                    if (temp[0].trim() <= this.throwDistance2screenSizWidth && temp[1].trim() >= this.throwDistance2screenSizWidth) {
                      this.radioLens = i
                      break
                    }
                  }
                } else if (Number(this.tableDataLens[i].throwRatio.trim()) === this.throwDistance2screenSizWidth) {
                  this.radioLens = i
                  break
                }
              } else if (this.searchTabActive === 'Specification') {
                let temp = this.tableDataLens[i].throwRatio.split('-')
                if (temp[0].trim() * 1 >= this.throwDistance2screenSizWidth[0] * 1 && !this.throwDistance2screenSizWidth[1]) {
                  this.radioLens = i
                  break
                } else if (temp[0].trim() * 1 >= this.throwDistance2screenSizWidth[0] * 1 && this.throwDistance2screenSizWidth[1] && temp[0].trim() * 1 <= this.throwDistance2screenSizWidth[1] * 1) {
                  this.radioLens = i
                  break
                }
              }
            }
            this.onLensChange(this.tableDataLens[this.radioLens])
          })
        }
      } else {
        this.tableDataLens = []
      }
      this.SET_LENSLIST(this.tableDataLens)
    },

    renderheader (h, {column}) {
      return h('el-tooltip', {
        props: {
          effect: 'light',
          content: column.label,
          placement: 'top-start'
        }
      }, [
        h('span', column.label)
      ])
    }
  }
}
</script>
<style >
.oldLens {
  color:#adabab
}
.oldLensGray{
  color:#8497B0
}
.noHoverBG .el-table--enable-row-hover .el-table__body tr:hover>td {
  background: rgba(0,0,0,0) !important
}
.noHoverBG .el-table__body tr.current-row>td {
  background: rgba(0,0,0,0) !important
}
</style>
<style scoped>
.container {
  background: #fff;
  border: 1px solid #bdbdbd;
}

.line {
  position: relative;
  float: left;
}

.search-projector-result_img-line {
  width: 1px;
  height: 10px;
  border-right: 2px solid #409EFF;
}

.middle-line {
  width: 80px;
  height: 1px;
  border-top: 2px solid #409EFF;
  transform: translateY(4px);
}

.right-line {
  width: 1px;
  height: 10px;
  border-left: 2px solid #409EFF;
}
.lensDetailedInfo {
  text-align: left;
}
.lensDetailedInfo div {
  padding: 10px;
  padding-right: 0px;
}

.span-scale {
  position: absolute;
  color: #877575;
  font-size: 10px;
  margin-top: 15px
}
.span_throw_range_min {
  right: calc(100% - 8px);
}
.span_throw_range_one {
  right: calc(64%);

}
.span_throw_range_two {
  right: calc(30%);
}
.span_throw_range_max {
  right: 0px;
}
.span-left {
  float: left;
  /* margin-left: 5px; */
}
.span-right {
  float: right;
  /* margin-right: 5px; */
}

.span-center1 {
  margin-left: 85px
}

.span-center2 {
  margin-right: 75px;
}

.throw-range-container {
  position: relative;
  height: 22px;
}
.dividing-line {
  width: calc(100% / 15);
  height: 22px;
  border-left: 1px dashed #cccccc;
  float: left;
}
.throw-range-container div:nth-child(15n){
  border-right: 1px dashed;
}
.throw-range {
  position:absolute;
  height: 60%;
  top: 20%;
  background: #10218b;
  float:left;
  opacity: 0.7;
}

.throw-range-container div:nth-child(5n){
  border-right: 1px solid #cccccc;
}

.throw-range-container div:nth-child(6),
.throw-range-container div:nth-child(11),
.throw-range-container div:nth-child(1){
  border-left: none;
}
.unitDisplay {
  display: inline-block;
}
.block {
  display: inline-block;
}
.select_lens_note_dialog p{
  font-size: 14px;
  color: #666666;
  word-break: break-word;
}
.select_lens_note_dialog>>>.el-dialog__header {
  height: 180px;
  background: url('../../assets/parts/graph/out_of_spec_warning.png') no-repeat center;
}
.select_lens_note_dialog>>>.el-dialog__body{
  padding: 30px 25px;
}
.select_lens_note_dialog>>>.el-dialog__footer{
  padding:0 20px 40px 20px
}
.select_lens_note_dialog .el-button>>>span{
  padding: 10px
}
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/comparisonLens.vue